import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	DetachedRouteHandle,
	RouteReuseStrategy,
} from '@angular/router';

@Injectable()
export class AppRouteReuseStrategy implements RouteReuseStrategy {
	retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
		return undefined;
	}

	shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	shouldReuseRoute(
		future: ActivatedRouteSnapshot,
		curr: ActivatedRouteSnapshot
	): boolean {
		return !future.data?.skipReuse && curr.routeConfig === future.routeConfig;
	}

	store(
		route: ActivatedRouteSnapshot,
		handle: DetachedRouteHandle | null
	): void {
		return;
	}
}
